export default __webpack_public_path__ + "static/media/ico-plus-white.6d4047b1.svg";